import FollowerStats from "../../Components/Base/Charts/FollowerStats";
import { InfluencerRating } from "../../Components";
import { Instagram } from "lucide-react";
import React from "react";

export const ProfileDetails = ({ profileData }) => {
  const defaultData = {
    avg_comments: "60",
    avg_likes: "950",
    engagement_rate: 3.8,
    fake_perc: 10,
    followers: "18000",
    following: "500",
    id: 1,
    posts: "300",
    real_perc: 90,
  };

  const data =
    profileData && Object.keys(profileData).length > 0
      ? profileData
      : defaultData;
  const pieChartData = {
    avg_comments: data.avg_comments || defaultData.avg_comments,
    avg_likes: data.avg_likes || defaultData.avg_likes,
    engagement_rate: data.engagement_rate || defaultData.engagement_rate,
    fake_perc: data.fake_perc || defaultData.fake_perc,
    followers: data.followers || defaultData.followers,
    following: data.following || defaultData.following,
    id: data.id || defaultData.id,
    posts: data.posts || defaultData.posts,
    real_perc: data.real_perc || defaultData.real_perc,
  };
  return (
    <div className="flex flex-col md:flex-row gap-8 shadow-md rounded-lg my-8 p-8 bg-white">
      <div className="flex-1">
        <div className="flex items-center mb-5">
          <img
            alt="Profile picture"
            className="rounded-full w-20 h-20 mr-4 flex-shrink-0"
            src={`${process.env.PUBLIC_URL}/images/placeholder/avatar.png`}
          />
          <div>
            <h1 className="text-2xl m-0 text-gray-800 font-bold text-left leading-8">
              {data.handle || "John Doe"}
            </h1>
            {/* <p className="m-0 text-gray-600 text-left mb-2.5">India</p> */}
            <div className="ml-auto flex items-center flex-wrap gap-2.5">
              <span
                // key={`ig-${i}`}
                className="flex items-center px-2 py-2 border border-gray-500 rounded-lg shadow-sm bg-white font-bold text-gray-900 gap-1"
              >
                <Instagram color="#19ae52" />
                <span className="pt-1">{data.followers || "392.9M"}</span>
                <span></span>
              </span>
            </div>
          </div>
        </div>

        <div className="flex justify-between w-full items-center my-8">
          <div className="flex gap-1 justify-center">
            <InfluencerRating infrating={4} />
          </div>
        </div>

        <div className="text-sm text-gray-800">
          <p className="flex justify-between w-full">
            A passionate influencer in the tech and lifestyle niches. Engaging
            content and brand collaborations.
          </p>
        </div>
      </div>

      <div className="flex-1 flex flex-col justify-end relative mt-8 md:mt-0">
        <div className="md:absolute md:top-0 md:right-0 mb-4 md:mb-0">
          <div className="relative inline-block">
            {/* <button className="px-4 py-2 bg-white border text-black rounded-full text-sm font-medium shadow-sm flex items-center gap-1">
              Analytics
            </button>
            <span className="absolute -top-2 -right-2 text-white text-[10px] font-semibold px-2 py-[2px] rounded-full bg-[linear-gradient(90deg,_rgb(94,176,90)_0%,_rgb(54,122,64)_50%,_rgb(16,38,32)_100%)] shadow">
              Coming Soon
            </span> */}
          </div>
        </div>

        <div className="my-auto">
          <FollowerStats data={pieChartData} />
        </div>
      </div>
    </div>
  );
};
